import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { WebsiteThemeService } from '../../../services/website-theme.service';
import { Router } from "@angular/router";
import { ComponentService } from "../../../services/component.service";
import { LocationStrategy } from "@angular/common";
import { SharedHttp } from "../../../services/http-client.service";
import { WebClientService } from "../../../services/webclient-settings.service";
import { AuthService } from '../../../services/auth.service';
import { LanguageService } from "../../../services/language.service";
/**
 * Update user data on wallet
 */
let UpdateUserDataWalletModalComponent = class UpdateUserDataWalletModalComponent {
    constructor(sanitizer, router, httpClient, compService, location, themeService, webSettingsService, auth, languageService) {
        this.sanitizer = sanitizer;
        this.router = router;
        this.httpClient = httpClient;
        this.compService = compService;
        this.location = location;
        this.themeService = themeService;
        this.webSettingsService = webSettingsService;
        this.auth = auth;
        this.languageService = languageService;
        this.secondColor = '';
        this.accentColor = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.errorColor = '';
        this.allEmploymentTypes = [];
        this.allEmploymentTypesByLang = [];
        this.professions = [];
        this.professionsByLang = [];
        this.eatas = [];
        this.poaos = [];
        this.poaosByLang = [];
        this.user = JSON.parse(localStorage.getItem('user'));
        this.themeService.getTheme().subscribe((data) => {
            this.secondColor = this.themeService.getStyleAttribute('secondary_text_color');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
        });
        this.languageService.getChosenLanguage().subscribe((lang) => {
            var _a, _b, _c;
            this.lang = lang ? lang : 'en';
            this.allEmploymentTypesByLang = this.allEmploymentTypes ? this.allEmploymentTypes.filter(employmentType => employmentType.lang === this.lang) : [];
            this.professionsByLang = this.professions ? this.professions.filter(profession => profession.lang === this.lang) : [];
            this.poaosByLang = this.poaos ? this.poaos.filter(poao => poao.lang === this.lang) : [];
            if (this.employmentTypeName) {
                this.employmentTypeName = (_a = this.allEmploymentTypesByLang.find(employmentType => employmentType.id === this.employmentType)) === null || _a === void 0 ? void 0 : _a.name;
            }
            if (this.professionName) {
                this.professionName = (_b = this.professionsByLang.find(profession => profession.id === this.professionId)) === null || _b === void 0 ? void 0 : _b.name;
            }
            if (this.poaoName) {
                this.poaoName = (_c = this.poaosByLang.find(poao => poao.id === this.poaoId)) === null || _c === void 0 ? void 0 : _c.name;
            }
        });
        location.onPopState(() => {
            this.close();
        });
    }
    ngOnInit() {
        if (!this.user.newDataPopulated) {
            this.getEmploymentTypes();
            this.getProfessions();
        }
        if (!this.user.eataandpoaosPopulated) {
            this.getPoaos();
        }
    }
    close() {
        this.modal.destroy();
    }
    expandEmploymenTypes() {
        this.employmentTypeExpanded = !this.employmentTypeExpanded;
        this.professionExpanded = false;
        this.poaoExpanded = false;
    }
    fillEmploymentType(id, name) {
        this.employmentType = id;
        this.employmentTypeName = name;
    }
    fillEata(id, name) {
        this.eataId = id;
        this.eataName = name;
    }
    expandEata() {
        this.eataExpanded = !this.eataExpanded;
    }
    otherEatakeyup(value) {
        if (this.otherEata === 'null' || this.otherEata === '') {
            this.otherEataError = true;
        }
        else {
            this.otherEataError = false;
        }
    }
    fillPoao(id, name) {
        this.poaoId = id;
        this.poaoName = name;
    }
    expandPoao() {
        this.poaoExpanded = !this.poaoExpanded;
        this.professionExpanded = false;
        this.employmentTypeExpanded = false;
    }
    checkPoao() {
        if (this.poaoId == "null" || this.poaoId === undefined) {
            this.poaoError = true;
        }
        else {
            this.poaoError = false;
        }
    }
    fillProfession(id, name) {
        this.professionId = id;
        this.professionName = name;
        if (id != -1) {
            this.otherProfession = '';
        }
    }
    expandProfession() {
        this.professionExpanded = !this.professionExpanded;
        this.employmentTypeExpanded = false;
        this.poaoExpanded = false;
    }
    getProfessions() {
        this.httpClient.get('user/professions').subscribe((data) => {
            this.professions = data;
            this.professionsByLang = this.professions ? this.professions.filter(profession => profession.lang === this.lang) : [];
        });
    }
    getEatas() {
        var language = localStorage.getItem('language');
        if (language == null) {
            language = this.lang;
        }
        this.httpClient.get('user/eatas/' + language).subscribe((data) => {
            this.eatas = data;
        }, (error) => {
        });
    }
    getPoaos() {
        this.httpClient.get('user/poaos').subscribe((data) => {
            this.poaos = data;
            this.poaosByLang = this.poaos ? this.poaos.filter(poao => poao.lang === this.lang) : [];
        });
    }
    getEmploymentTypes() {
        this.httpClient.get('user/employmenttypes').subscribe((data) => {
            this.allEmploymentTypes = data;
            this.allEmploymentTypesByLang = this.allEmploymentTypes ? this.allEmploymentTypes.filter(employmentType => employmentType.lang === this.lang) : [];
        });
    }
    otherProfessionkeyup(value) {
        this.checkOtherProfession();
    }
    checkOtherProfession() {
        if (this.professionId == -1) {
            if (this.otherProfession === 'null' || this.otherProfession === '' || this.otherProfession === undefined) {
                this.otherProfessionError = true;
                return;
            }
            else {
                this.otherProfessionError = false;
            }
        }
        else {
            this.otherProfessionError = false;
        }
    }
    onResidentSelectionChange(entry) {
        this.resident = entry;
        this.residentError = false;
    }
    checkProfession() {
        if (this.professionId == "null" || this.professionId === undefined) {
            this.professionError = true;
        }
        else {
            this.professionError = false;
        }
    }
    checkEmploymentType() {
        if (this.employmentType == "null" || this.employmentType === undefined) {
            this.employmentTypeError = true;
        }
        else {
            this.employmentTypeError = false;
        }
    }
    checkEata() {
        if (this.eataName == "null" || this.eataName === undefined) {
            this.eataError = true;
        }
        else {
            this.eataError = false;
        }
    }
    checkResident() {
        if (this.resident === undefined || this.resident == null) {
            this.residentError = true;
        }
    }
    checkOtherEata() {
        if (this.eataId === '-1') {
            if (this.otherEata === 'null' || this.otherEata === '') {
                this.otherEataError = true;
            }
            else {
                this.otherEataError = false;
            }
        }
    }
    submitData() {
        if (!this.user.newDataPopulated) {
            this.checkProfession();
            this.checkOtherProfession();
            this.checkEmploymentType();
            this.checkResident();
            if (!this.otherProfessionError &&
                !this.residentError &&
                !this.professionError &&
                !this.employmentTypeError) {
                this.httpClient.post('user/updateuserdata', {
                    "employmentTypeId": this.employmentType,
                    "resident": this.resident,
                    "professionId": this.professionId,
                    "otherProfession": this.otherProfession,
                    "isPoaoAndEatas": false
                })
                    .subscribe((result) => {
                    this.auth.fetchUser();
                    this.close();
                }, (error) => {
                });
            }
        }
        if (!this.user.eataandpoaosPopulated) {
            this.checkPoao();
            if (!this.poaoError) {
                this.httpClient.post('user/updateuserdata', {
                    "eataId": this.eataId,
                    "poaoId": this.poaoId,
                    "otherEata": this.otherEata,
                    "isPoaoAndEatas": true
                })
                    .subscribe((result) => {
                    this.auth.fetchUser();
                    this.close();
                }, (error) => {
                });
            }
        }
    }
};
UpdateUserDataWalletModalComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: Router },
    { type: SharedHttp },
    { type: ComponentService },
    { type: LocationStrategy },
    { type: WebsiteThemeService },
    { type: WebClientService },
    { type: AuthService },
    { type: LanguageService }
];
UpdateUserDataWalletModalComponent = __decorate([
    Component({
        selector: 'update-user-data-wallet-modal.component',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./update-user-data-wallet-modal.component.html")).default
    })
], UpdateUserDataWalletModalComponent);
export { UpdateUserDataWalletModalComponent };
